import React from 'react';

import { ToolbarButton } from '..';
import { buttonsArray } from '../../configs';

interface Props {
  id?: string;
  style?: React.CSSProperties;
  isDisabled?: boolean;
}

export const ToolbarButtonsList = ({ id, style, isDisabled }: Props) => (
  <ul id={id} style={style}>
    {buttonsArray.map(button => (
      <li key={button.id}>
        <ToolbarButton {...button} disabled={isDisabled} />
      </li>
    ))}
  </ul>
);
